var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_user-agent.js
// module id = 496
// module chunks = 0